import React, { useState } from "react";
import Select from "react-dropdown-select";
import { FiUploadCloud } from "react-icons/fi";
import "./SheetBulkUploadPopup.scss";
import { useDispatch } from "react-redux";
import { SheetBulkUploadSucess } from "../../../Redux/Slice";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const SheetBulkUploadPopup = ({ setPopup }) => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();

  const [fileType, setFileType] = useState([
    {
      value: "Client",
      label: "Client",
    },
  ]);

  const options = [
    { value: "Client", label: "Client" },
    { value: "Existing Employee", label: "Existing Employee" },
  ];

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const MAX_SIZE = 250 * 1024 * 1024; // 250MB

  //  Validate file
  const validateFile = (uploadedFile) => {
    if (!uploadedFile) return false;

    if (!allowedTypes.includes(uploadedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      return false;
    }

    if (uploadedFile.size > MAX_SIZE) {
      toast.error("File size should be less than 250MB");
      return false;
    }

    return true;
  };

  //  Drag & Drop
  const handleDrop = (e) => {
    e.preventDefault();

    const uploadedFile = e.dataTransfer.files[0];

    if (!validateFile(uploadedFile)) return;

    setFile(uploadedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  //  File Input
  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];

    if (!validateFile(uploadedFile)) return;

    setFile(uploadedFile);
  };

  //  Upload
  const uploadFile = () => {
    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const payload = {
      report_type: fileType?.[0]?.value === "Existing Employee" ? "1" : "0",
      file: file,
      setPopup, // (you can remove later as discussed)
    };

    dispatch(SheetBulkUploadSucess(payload));
  };

  // Sample Download
  const downloadSample = () => {
    const type = fileType?.[0]?.value;

    let data = [];

    if (type === "Client") {
      data = [
        [
          "Client Name",
          "Client Branch",
          "Branch Code",
          "Address",
          "State",
          "Prefix",
          "Sequence",
          "Region",
          "Zone",
          "Reporting Persons (EMAIL OR PHONE NUMBER)",
          "Attendance Feature Type",
          "Latitude",
          "Longitude",
          "Attendance Capture Radius (meters)",
        ],
      ];
    } else {
      data = [
        [
          "S No",
          "First Name",
          "Last Name",
          "Employee Code",
          "Email",
          "Phone Number",
          "Designation",
          "Client Name",
          "Client Branch",
          "Branch Code",
          "Salary",
          "Wage Type (daily,weekly,monthly)",
          "Marital Status",
          "Date of Joining",
          "Date of Birth",
          "Gender",
          "Aadhar Number",
          "Pan Number",
          "UAN number",
          "Bank Name",
          "Account Number",
          "IFSC CODE",
          "Bank Branch",
          "PF Account Number",
          "Father Name (Optional)",
          "Husband Name (Optional)",
          "ESIC",
        ],
      ];
    }

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");

    // Download as .xlsx
    XLSX.writeFile(wb, `${type}_Sample.xlsx`);
  };

  return (
    <div className="overlay">
      <div className="popupContainers">
        {/* Header */}
        <div className="popupHeader">
          <div />
          <span className="TitleHeader">Sheet Upload</span>
          <button className="closeButton" onClick={() => setPopup(false)}>
            ×
          </button>
        </div>

        {/* Dropdown */}
        <div className="uploadTypeHeader">
          <Select
            className="Selects"
            options={options}
            values={fileType}
            onChange={(value) => setFileType(value)}
            style={{ width: "480px", marginBottom: "0px" }}
            dropdownStyle={{ width: "480px" }}
          />

          <button className="sampleSheetBtn" onClick={downloadSample}>
            Sample Sheet
          </button>
        </div>

        {/* Drag & Drop */}
        <div
          className="uploadBox"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <FiUploadCloud className="uploadIcon" />

          <p className="mainText">
            Click to select or drag & drop your Excel file
          </p>

          <p className="subText">Supported formats: .xls, .xlsx</p>
          <p className="subText">Max file size 250MB</p>

          <input type="file" onChange={handleFileChange} accept=".xls,.xlsx" />

          {file && <p className="fileName">{file.name}</p>}
        </div>

        {/* Submit */}
        <button className="submitBtn" disabled={!file} onClick={uploadFile}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default SheetBulkUploadPopup;
